import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Privacy() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: '#0A0A0A', padding: '60px 24px' }}>
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 48 }}>
          <div style={{ width: 36, height: 36, background: '#00C853', borderRadius: 8, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }} onClick={() => navigate(-1)}>
            <svg width="18" height="18" viewBox="0 0 44 44" fill="none">
              <polyline points="4,10 13,34 22,18 31,34 40,10" stroke="#0A0A0A" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
            </svg>
          </div>
          <span style={{ fontSize: 18, fontWeight: 500, color: '#FFFFFF' }}>Win<span style={{ color: '#00C853' }}>al</span></span>
        </div>

        <h1 style={{ fontSize: 32, fontWeight: 700, color: '#FFFFFF', marginBottom: 8 }}>Política de Privacidad</h1>
        <p style={{ fontSize: 13, color: '#666666', marginBottom: 48 }}>Última actualización: Abril 2026</p>

        {[
          {
            title: '1. Información que recopilamos',
            content: 'Recopilamos: (a) Datos de cuenta: nombre, email y foto de perfil de Google. (b) Datos comerciales: leads, oportunidades, conversaciones de WhatsApp y métricas de ventas que tu equipo registra. (c) Datos de uso: cómo interactuás con la plataforma para mejorar el servicio. (d) Datos de pago: procesados por MercadoPago — no almacenamos datos de tarjetas.'
          },
          {
            title: '2. Cómo usamos la información',
            content: 'Usamos tu información para: proveer y mejorar el servicio, procesar pagos, enviarte notificaciones del sistema, analizar el uso agregado para mejorar la plataforma, y cumplir con obligaciones legales. No usamos tus datos para publicidad de terceros.'
          },
          {
            title: '3. Almacenamiento y seguridad',
            content: 'Tus datos se almacenan en Google Firebase (infraestructura de Google Cloud). Usamos cifrado en tránsito (HTTPS) y en reposo. Acceso restringido solo al personal autorizado de Winal. Realizamos backups automáticos diarios. En caso de brecha de seguridad, te notificamos dentro de las 72 horas.'
          },
          {
            title: '4. Compartir información',
            content: 'Compartimos datos únicamente con: (a) Servicios que vos configurás explícitamente: HubSpot, Slack. (b) Procesadores de pago: MercadoPago para gestión de suscripciones. (c) Infraestructura técnica: Google Firebase, Twilio (WhatsApp), Railway. Nunca vendemos tu información a terceros.'
          },
          {
            title: '5. WhatsApp y mensajería',
            content: 'Los mensajes intercambiados con el bot de Winal por WhatsApp se procesan y almacenan para proveer el servicio. Twilio actúa como intermediario para la entrega de mensajes. Los contenidos de las conversaciones son visibles para el manager del equipo en el dashboard. Los vendedores deben ser informados de que sus conversaciones con el bot son monitoreadas.'
          },
          {
            title: '6. Tus derechos',
            content: 'Tenés derecho a: acceder a todos tus datos, corregir información incorrecta, solicitar la eliminación de tus datos (derecho al olvido), portabilidad de datos en formato JSON, y oponerte al procesamiento de tus datos. Para ejercer estos derechos, contactanos en hola@winal.app'
          },
          {
            title: '7. Retención de datos',
            content: 'Conservamos tus datos mientras tu cuenta esté activa. Al cancelar, los datos se retienen por 30 días antes de eliminarse permanentemente. Podés solicitar eliminación inmediata contactando soporte. Los datos de facturación se conservan por 5 años por obligaciones legales.'
          },
          {
            title: '8. Cookies',
            content: 'Usamos cookies de sesión para mantener tu autenticación activa. No usamos cookies de seguimiento ni publicidad. Podés configurar tu navegador para rechazar cookies, aunque esto puede afectar el funcionamiento del dashboard.'
          },
          {
            title: '9. Cambios a esta política',
            content: 'Podemos actualizar esta política. Te notificaremos por email con 30 días de anticipación ante cambios significativos. El uso continuo del servicio después de los cambios implica aceptación.'
          },
          {
            title: '10. Contacto',
            content: 'Para consultas sobre privacidad o para ejercer tus derechos, contactanos en hola@winal.app. Respondemos dentro de las 48 horas hábiles.'
          },
        ].map((section, i) => (
          <div key={i} style={{ marginBottom: 36 }}>
            <h2 style={{ fontSize: 18, fontWeight: 600, color: '#FFFFFF', marginBottom: 12 }}>{section.title}</h2>
            <p style={{ fontSize: 14, color: '#888888', lineHeight: 1.8, margin: 0 }}>{section.content}</p>
          </div>
        ))}

        <div style={{ marginTop: 48, paddingTop: 24, borderTop: '1px solid #1A1A1A', textAlign: 'center' }}>
          <button onClick={() => navigate(-1)} style={{ background: '#00C853', color: '#0A0A0A', border: 'none', borderRadius: 8, padding: '10px 28px', fontSize: 14, fontWeight: 500, cursor: 'pointer' }}>
            ← Volver
          </button>
        </div>
      </div>
    </div>
  );
}